import { Button, Typography } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import { ReactComponent as SparklesIcon } from "../../../icons/Advisor/Sparkles.svg";
import useIsMobile from "components/hooks/useIsMobile";

import {
  TASK_INSPO_WEEKLY_RECAP,
  TASK_INSPO_PERSONALIZED_TASKS,
  TASK_INSPO_FAMILY_DOSSIER_PATH,
  TaskInspirationLink,
  createTaskInspirationLink,
} from "./constants";

const InspirationButton = ({
  inspiration,
  children,
  familyRef,
}: {
  inspiration: TaskInspirationLink;
  children: React.ReactNode;
  familyRef?: string;
}) => (
  <Button
    href={createTaskInspirationLink({
      ...inspiration,
      familyRef,
    })}
    variant="text"
    startIcon={<SparklesIcon />}
    sx={{
      height: "auto",
      lineHeight: "1.3",
      alignItems: "start",
      "& .MuiButton-startIcon": { marginLeft: "0" },
    }}
  >
    {children}
  </Button>
);

export default ({ flex, familyRef }: { flex: number; familyRef?: string }) => {
  const isMobile = useIsMobile();

  return (
    <FlexBox variant="contained" direction="column" sx={{ flex: flex }}>
      <Typography variant={isMobile ? "h3" : "h4"}>Magic docs</Typography>
      <FlexBox direction="column" gap="8px">
        <InspirationButton
          inspiration={TASK_INSPO_WEEKLY_RECAP}
          familyRef={familyRef}
        >
          Weekly recap
        </InspirationButton>
        <InspirationButton
          inspiration={TASK_INSPO_PERSONALIZED_TASKS}
          familyRef={familyRef}
        >
          Personalized task ideas
        </InspirationButton>
        <InspirationButton
          inspiration={TASK_INSPO_FAMILY_DOSSIER_PATH}
          familyRef={familyRef}
        >
          Family dossier
        </InspirationButton>
      </FlexBox>
    </FlexBox>
  );
};
